import { IconNames } from '@blueprintjs/icons';
import { DetailLabel, DetailLabelValuePair } from '@strata/react-label-value-pairs';
import { BaseNotification } from '@strata/react-notifications';
import { CountdownTimer } from '@strata/react-timers';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

export const PendingReauthNotification = ({
    productName,
    patientName,
    timestamp,
    additionalData,
    onNotificationClick,
    onRemoveNotificationClick,
    status,
    small,
}) => (
    <BaseNotification
        notificationTitle="Action Required"
        icon={IconNames.WARNING_SIGN}
        bodyText={`${productName} for ${patientName} is pending reauth.`}
        timestamp={timestamp}
        onNotificationClick={onNotificationClick}
        onRemoveNotificationClick={onRemoveNotificationClick}
        type={BaseNotification.Types.WARNING}
        status={status}
        lapsed={dayjs().isAfter(additionalData.referralExpiration)}
        additionalData={
            <>
                <div style={{ width: '25%' }}>
                    <DetailLabel label="Time Remaining" />
                    <CountdownTimer endTime={additionalData.referralExpiration} />
                </div>
                {!small && (
                    <DetailLabelValuePair label="Health Plan" value={additionalData.healthPlan} />
                )}
            </>
        }
    />
);

PendingReauthNotification.propTypes = {
    timestamp: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    patientName: PropTypes.string.isRequired,
    onNotificationClick: PropTypes.func.isRequired,
    onRemoveNotificationClick: PropTypes.func.isRequired,
    status: PropTypes.oneOf(Object.values(BaseNotification.Statuses)).isRequired,
    small: PropTypes.bool.isRequired,
    additionalData: PropTypes.shape({
        referralExpiration: PropTypes.string.isRequired,
        healthPlan: PropTypes.string.isRequired,
    }).isRequired,
};
